export default __webpack_public_path__ + "static/media/captur-colour-1.38d21b76.jpg";